import React from 'react';
import { IconButton, useTheme, useMediaQuery } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { useNavigation } from './NavigationContext';

const MobileDrawerToggle: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { toggleSidebar, sidebarOpen } = useNavigation();

  if (!isMobile || sidebarOpen) {
    return null;
  }

  return (
    <IconButton
      onClick={toggleSidebar}
      sx={{
        position: 'fixed',
        top: 16,
        left: 16,
        zIndex: theme.zIndex.drawer - 1,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
        '&:hover': {
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <Menu />
    </IconButton>
  );
};

export default MobileDrawerToggle;
